import { TVerifyOtpReq } from "@sharedTypes/req.type";
import { TVerifyOtpRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function VerifyOtp(email: string, otp: string) {
  const apiUrl = "/email/verifyotp";

  const body: TVerifyOtpReq = {
    email,
    otp,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TVerifyOtpRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
